function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "filtres",
  transform: "translate(-233.489 -408.593)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_239",
  "data-name": "Grupo 239"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_1473",
  "data-name": "Caminho 1473",
  d: "M256.308,410.4h-21.52a1.388,1.388,0,0,0,0,2.77h21.52a1.387,1.387,0,0,0,0-2.77Z",
  fill: "#1781a1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_1474",
  "data-name": "Caminho 1474",
  d: "M251.416,408.593a3.2,3.2,0,1,0,3.2,3.2A3.2,3.2,0,0,0,251.416,408.593Z",
  fill: "#1781a1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_240",
  "data-name": "Grupo 240"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_1475",
  "data-name": "Caminho 1475",
  d: "M256.308,427.157h-21.52a1.387,1.387,0,0,0,0,2.769h21.52a1.387,1.387,0,0,0,0-2.769Z",
  fill: "#1781a1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_1476",
  "data-name": "Caminho 1476",
  d: "M251.416,425.352a3.2,3.2,0,1,0,3.2,3.2A3.2,3.2,0,0,0,251.416,425.352Z",
  fill: "#1781a1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_241",
  "data-name": "Grupo 241"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_1477",
  "data-name": "Caminho 1477",
  d: "M256.308,418.778h-21.52a1.387,1.387,0,0,0,0,2.769h21.52a1.387,1.387,0,0,0,0-2.769Z",
  fill: "#1781a1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_1478",
  "data-name": "Caminho 1478",
  d: "M239.687,416.973a3.2,3.2,0,1,0,3.2,3.2A3.2,3.2,0,0,0,239.687,416.973Z",
  fill: "#1781a1"
})));
function SvgDesktopFiltres(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.125,
    height: 23.138,
    viewBox: "0 0 24.125 23.138",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopFiltres);
export default __webpack_public_path__ + "static/media/desktop_filtres.ffaeec0b.svg";
export { ForwardRef as ReactComponent };